import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY = "iddl_admin_token";

export const adminToken = {
  get: () => localStorage.getItem(ADMIN_KEY) || "",
  set: (t) => localStorage.setItem(ADMIN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_KEY),
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  if (config.url && config.url.startsWith("/admin/")) {
    config.headers["X-Admin-Token"] = adminToken.get();
  }
  return config;
});

export const startAttempt = (body) =>
  api.post("/candidates/start", body).then((r) => r.data);
export const getAttempt = (id, lang) =>
  api
    .get(`/attempts/${id}`, { params: lang ? { lang } : {} })
    .then((r) => r.data);
export const submitKnowledge = (id, body) =>
  api.post(`/attempts/${id}/knowledge`, body).then((r) => r.data);
export const ingestEvent = (id, body) =>
  api.post(`/attempts/${id}/capability/event`, body).then((r) => r.data);
export const finalizeCapability = (id, body) =>
  api.post(`/attempts/${id}/capability/finalize`, body).then((r) => r.data);
export const submitReflection = (id, body) =>
  api.post(`/attempts/${id}/reflection`, body).then((r) => r.data);
export const advanceAttempt = (id) =>
  api.post(`/attempts/${id}/advance`).then((r) => r.data);
export const getResult = (id) =>
  api.get(`/attempts/${id}/result`).then((r) => r.data);
export const verifyLicense = (lid) =>
  api.get(`/verify/${lid}`).then((r) => r.data);
export const certificateUrl = (lid) => `${API}/license/${lid}/certificate`;
export const attemptCertificateUrl = (id) => `${API}/attempts/${id}/certificate`;

export const adminListAttempts = () =>
  api.get("/admin/attempts").then((r) => r.data);
export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then((r) => r.data);
export const adminGetAttempt = (id) =>
  api.get(`/admin/attempts/${id}`).then((r) => r.data);
export const adminToggleApprove = (id) =>
  api.post(`/admin/attempts/${id}/approve`).then((r) => r.data);
export const adminDeleteAttempt = (id) =>
  api.delete(`/admin/attempts/${id}`).then((r) => r.data);
export const adminModelAnswersUrl = () => `${API}/admin/model-answers`;
export const adminAttemptsXlsxUrl = () => `${API}/admin/attempts.xlsx`;
export const adminResearchExportXlsxUrl = () => `${API}/admin/research_export.xlsx`;
export const adminConceptConfigsXlsxUrl = () => `${API}/admin/concept_configs.xlsx`;
export const adminQuestionsXlsxUrl = () => `${API}/admin/questions.xlsx`;
export const attemptPdfUrl = (id) => `${API}/attempts/${id}/attempt_pdf`;
export const adminListQuestions = () =>
  api.get("/admin/questions").then((r) => r.data);
export const adminUpsertQuestion = (payload) =>
  api.post("/admin/questions", payload).then((r) => r.data);
export const adminDeleteQuestion = (qid) =>
  api.delete(`/admin/questions/${qid}`).then((r) => r.data);

// Database browser
export const adminDbIndex = () =>
  api.get("/admin/db").then((r) => r.data);
export const adminDbList = (collection, params = {}) =>
  api.get(`/admin/db/${collection}`, { params }).then((r) => r.data);
export const adminDbGet = (collection, id) =>
  api.get(`/admin/db/${collection}/${id}`).then((r) => r.data);
export const adminDbUpdate = (collection, id, payload) =>
  api.put(`/admin/db/${collection}/${id}`, payload).then((r) => r.data);
export const adminDbDelete = (collection, id) =>
  api.delete(`/admin/db/${collection}/${id}`).then((r) => r.data);
